import { v4 as uuidv4 } from "uuid";
import { makeAutoObservable, reaction } from "mobx";
import Question from "./Question";

class FormSection {
  constructor(
    id = uuidv4(),
    name = "",
    order = 0,
    questions = [],
    form = null
  ) {
    //Valorar si volem ficar que es puguin dividir per parts els questionaris (mirar com queda sense)
    this.id = id;
    this.name = name;
    this.order = order;
    this.questions = questions;
    this.form = form;
    makeAutoObservable(this);
  }

  updateUserSection(sectionData) {
    console.log("updateUserSection");

    this.name = sectionData.name;
    this.order = sectionData.order;

    if (sectionData.questions) {
      /* ELIMINAR QUESTIONS */
      const firestoreQuestionIDs = new Set(
        sectionData.questions.map((q) => q.id)
      );

      const localQuestionIDs = new Set(
        this.questions.map((q) => q.id.toString())
      );
      const deletedQuestionIDs = [...localQuestionIDs].filter(
        (id) => !firestoreQuestionIDs.has(id)
      );

      deletedQuestionIDs.forEach((id) => {
        const index = this.questions.findIndex(
          (question) =>
            question.id.toString().toLowerCase() === id.toLowerCase()
        );

        if (index !== -1) {
          this.questions.splice(index, 1);
        }
      });
      sectionData.questions.forEach((questionData) => {
        const internalQuestion = this.questions.find(
          (q) => q.id.toString().toLowerCase() === questionData.id.toLowerCase()
        );

        if (internalQuestion) {
          internalQuestion.updateUserQuestion(questionData);
        } else {
          console.log("fetchUserQuestion");
          this.fetchUserQuestion(questionData);
        }
      });
    }
  }

  fetchUserQuestion(questionData) {
    try {
      const newQuestion = new Question(
        questionData.id,
        questionData.question,
        questionData.type,
        questionData.answer,
        questionData.order,
        this
      );
      this.questions.push(newQuestion);
      return newQuestion;
    } catch (error) {
      console.error("Error creating question", error);
    }
  }

  addQuestion() {
    const newOrder = this.questions[this.questions.length - 1]
      ? this.questions[this.questions.length - 1].order + 1
      : 0;
    const newQuestion = new Question(uuidv4(), "", "Texto", "", newOrder, this);

    this.questions.push(newQuestion);
  }

  deleteQuestion(question) {
    // Find the index of the question to be deleted
    const index = this.questions.findIndex((q) => q === question);

    // Check if the question was found
    if (index > -1 && this.questions.length > 1) {
      // Remove the question from the array
      this.questions.splice(index, 1);

      // Optionally, you could add any additional logic here,
      // like logging the deletion, updating related data, etc.
    }

    // this.updateFormTransactionData();
  }

  setProperty(propertyName, value) {
    if (Object.hasOwnProperty.call(this, propertyName)) {
      this[propertyName] = value;
    } else {
      console.error(`Property ${propertyName} does not exist.`);
    }
  }
  getProperty(propertyName) {
    if (Object.hasOwnProperty.call(this, propertyName)) {
      return this[propertyName];
    } else {
      console.error(`Property ${propertyName} does not exist.`);
      return undefined;
    }
  }
}
export default FormSection;
